module.exports = "/wp-content/themes/conversion/public/dist//svgs/arrow_right_alt.svg";